<dx-data-grid
  #grid
  [dataSource]="mouvements"
  keyExpr="id"
  height="100%"
  [hoverStateEnabled]="true"
  [allowColumnResizing]="true"
  [rowAlternationEnabled]="false"
  [showRowLines]="true"
  [showBorders]="true"
  [columnAutoWidth]="true"
  columnResizingMode="widget"
  (onInitialized)="onInitialized()">
  <dxo-paging [pageSize]="25"></dxo-paging>
  <dxo-pager
    [visible]="true"
    [showPageSizeSelector]="true"
    [allowedPageSizes]="[25, 50, 100, 200]"
    [showNavigationButtons]="true"
    [showInfo]="true"
    infoText="{2} mouvement(s)">
  </dxo-pager>

  <dxi-column dataField="id"
              alignment="left"
              caption="Actions"
              [width]="70"
              class="header"
              [allowFiltering]="false"
              [allowGrouping]="false"
              cellTemplate="actionsCellTemplate">
  </dxi-column>

  <dxi-column dataField="entreeSortie"
              alignment="center"
              caption="E/S"
              [width]="40"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false"
              cellTemplate="esTemplate">
  </dxi-column>

  <dxi-column dataField="stockMouvementStatutCode"
              alignment="left"
              caption="Motif"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false"
              cellTemplate="stTemplate">
  </dxi-column>

  <dxi-column dataField="dateMouvement"
              alignment="left"
              caption="Date du mouvement"
              dataType="date"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>

  <dxi-column dataField="zdsLibelle"
              alignment="left"
              caption="Emplacement"
              cellTemplate="emplacementTemplate"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>

  <dxi-column dataField="denominationArticle"
              alignment="left"
              caption="Dénomination"
              cellTemplate="denominationArticleTemplate"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>

  <dxi-column dataField="fournisseurLibelle"
              alignment="left"
              caption="Fournisseur filiale"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>

  <dxi-column dataField="quantite"
              alignment="left"
              caption="Quantité"
              cellTemplate="quantiteTemplate"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>

  <dxi-column dataField="prix"
              alignment="left"
              caption="Prix unitaire"
              cellTemplate="prixTemplate"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>

  <dxi-column dataField="tva"
              alignment="left"
              caption="TVA"
              cellTemplate="tvaTemplate"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>

  <dxi-column dataField="prixTotalHT"
              alignment="left" caption="HT"
              cellTemplate="prixTotalHTTemplate"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>

  <dxi-column dataField="prixTotalTTC"
              alignment="left"
              caption="TTC"
              cellTemplate="prixTotalTTCTemplate"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>

  <dxi-column dataField="lotArticleFournisseur"
              alignment="left"
              caption="Lot Fournisseur"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>

  <dxi-column dataField="lotArticle"
              alignment="left"
              caption="Lot Article"
              class="header"
              [allowGrouping]="false"
              [allowFiltering]="false">
  </dxi-column>

  <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT_INNER"
      tooltip="modifier le mouvement"
      iconClass="fa fa-edit"
      size="small"
      [disabled]="!auth2Svc.isSiteLocal(cell.row.data.site?.id)"
      (onClick)="openModification(cell.row.data)">
    </yo-button>
  </div>

  <div *dxTemplate="let cell of 'esTemplate'">
    @if (cell.row.data.entreeSortie) {
      <i class="fas fa-arrow-right new-color"
         title="Entrée de stock">
      </i>
    } @else {
      <i class="fas fa-arrow-left danger-color"
         title="Sortie de stock">
      </i>
    }
  </div>

  <div *dxTemplate="let cell of 'stTemplate'" id="stock-mouvement-statut-libelle">
    @if (containsRemarques(cell.row.data)) {
      <i title="Présence de remarque(s)"
         class="fas fa-comments text-warning">
      </i>
    }
    <span [title]="cell.row.data.stockMouvementStatutLibelle">
      {{cell.row.data.stockMouvementStatutLibelle}}
    </span>
  </div>

  <div *dxTemplate="let cell of 'emplacementTemplate'" id="emplacement-template">
    <div>
      <i class="fas fa-industry"></i> {{cell.row.data.udpLibelle}}
    </div>
    <div>
      <i class="fas fa-cubes"></i> {{cell.row.data.zdsLibelle}}
    </div>
  </div>

  <div *dxTemplate="let cell of 'denominationArticleTemplate'" id="denomination-article-template">
    {{cell.row.data.denominationArticle}}
    @if (cell.row.data.ratioUS === 0) {
      <span>
        <i class="fas fa-exclamation-triangle danger-color space"
          title="Le ratio d'unité de stockage de cet article est égal à 0">
        </i>
      </span>
    }
  </div>

  <div *dxTemplate="let cell of 'quantiteTemplate'">
    <span title="Quantité en unité de facturation : {{cell.row.data.quantiteEnUF}} {{cell.row.data.abrvUniteDeFacturation}} ">
      {{cell.row.data.quantite | number:'1.4-4'}}   {{cell.row.data.abrvUniteDeStockage}}
    </span>
  </div>

  <div *dxTemplate="let cell of 'prixTemplate'">
    {{cell.row.data.prixUnitaire  | currency:'EUR':'symbol':'1.4-4' }} / {{cell.row.data.abrvUniteDeFacturation}}
  </div>
  <div *dxTemplate="let cell of 'tvaTemplate'">
    {{cell.row.data.tva  | number:'1.2-2' }}%
  </div>
  <div *dxTemplate="let cell of 'prixTotalHTTemplate'">
    {{cell.row.data.prixTotalHT  | currency:'EUR':'symbol':'1.4-4' }}
  </div>
  <div *dxTemplate="let cell of 'prixTotalTTCTemplate'">
    {{cell.row.data.prixTotalTTC | currency:'EUR':'symbol':'1.4-4' }}
  </div>

</dx-data-grid>

<div class="balance-box">
  <div class="balance-sub-box">
    <span class="balance green">Entrées</span>
    <div class="currency-box">
      <span><strong class="new-color">{{balanceEntreesHT | currency:'EUR':'symbol':'1.4-4' }}</strong>HT</span>
      <span><strong class="new-color"> {{balanceEntreesTTC | currency:'EUR':'symbol':'1.4-4' }}</strong>TTC</span>
    </div>
  </div>

  <div class="balance-sub-box">
    <span class="balance red">Sorties</span>
    <div class="currency-box">
      <span><strong class="danger-color">  {{balanceSortiesHT | currency:'EUR':'symbol':'1.4-4' }}</strong>HT</span>
      <span><strong class="danger-color"> {{balanceSortiesTTC | currency:'EUR':'symbol':'1.4-4' }}</strong>TTC</span>
    </div>
  </div>


  <div class="balance-sub-box">
    <span class="balance">Balance</span>
    <div class="currency-box">
      <span><strong> {{balanceHT | currency:'EUR':'symbol':'1.4-4' }}</strong>HT</span>
      <span><strong> {{balanceTTC | currency:'EUR':'symbol':'1.4-4' }}</strong>TTC</span>
    </div>
  </div>
</div>

<yo-dialog-modification-mouvement></yo-dialog-modification-mouvement>
